import { useEffect, Component } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminInsights from "@/pages/AdminInsights";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BrandPlate from "@/components/BrandPlate";
import Stats from "@/components/Stats";
import Ventures from "@/components/Ventures";
import Experience from "@/components/Experience";
import Publications from "@/components/Publications";
import SocialLiterary from "@/components/SocialLiterary";
import Passion from "@/components/Passion";
import Engagement from "@/components/Engagement";
import Footer from "@/components/Footer";
import AIAssistant from "@/components/AIAssistant";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center bg-ink text-slate-300 p-8 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-grad">Something glitched.</p>
            <p className="mt-2 text-sm text-slate-500">Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <div className="App noise relative">
                <Nav />
                <main>
                  <Hero />
                  <Marquee />
                  <BrandPlate />
                  <Stats />
                  <Ventures />
                  <Experience />
                  <Publications />
                  <SocialLiterary />
                  <Passion />
                  <Engagement />
                </main>
                <Footer />
                <AIAssistant />
                <Toaster position="bottom-left" richColors theme="dark" />
              </div>
            }
          />
          <Route path="/admin" element={<AdminInsights />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;